"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 24,
      align: "right"
    }
  }, [_c("el-button", {
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "small",
      icon: "el-icon-plus"
    },
    on: {
      click: function ($event) {
        return _vm.toogleDialog("add");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.add")) + " New Contact ")])], 1)], 1), _c("br"), _c("el-dialog", {
    attrs: {
      title: "Manage Contact",
      visible: _vm.dialogVisible,
      "destroy-on-close": true,
      width: "75%"
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogVisible = $event;
      },
      close: _vm.getList
    }
  }, [_c("clients-contact-detail", {
    ref: "contactFormRef",
    attrs: {
      "is-edit": _vm.isEdit,
      "client-id": _vm.formData.id,
      "contact-id": _vm.contactId
    },
    on: {
      updated: function ($event) {
        _vm.dialogVisible = $event;
      }
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.clientContactList,
      border: "",
      fit: "",
      "highlight-current-row": ""
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "50",
      align: "center",
      label: "ID",
      prop: "id"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "200",
      label: "Name",
      prop: "fullName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("i", {
          staticClass: "el-icon-user"
        }), _vm._v(" " + _vm._s(scope.row.firstName + " " + (scope.row.lastName || "")) + " "), _c("br"), scope.row.designation ? _c("span", [_c("i", {
          staticClass: "el-icon-suitcase"
        }), _c("i", [_vm._v(" " + _vm._s(scope.row.designation) + " ")])]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "240",
      label: "Contact",
      prop: "fullName"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("i", {
          staticClass: "el-icon-mobile-phone"
        }), _vm._v(" " + _vm._s(scope.row.mobileNumber) + " "), _c("br"), _c("i", {
          staticClass: "el-icon-message"
        }), _vm._v(" " + _vm._s(scope.row.emailAddress) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      label: "Preference",
      prop: "communicationPreference",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return scope.row.communicationPreference ? [_c("el-tag", {
          attrs: {
            type: "info",
            size: "mini",
            effect: "dark"
          }
        }, [_vm._v(" " + _vm._s(scope.row.communicationPreference) + " ")])] : undefined;
      }
    }], null, true)
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      align: "center",
      label: "Is Primary",
      prop: "isPrimary"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-popconfirm", {
          attrs: {
            title: "Are you sure to update primary contact?",
            "icon-color": "#f00"
          },
          on: {
            confirm: function ($event) {
              return _vm.togglePrimary(scope.row);
            },
            cancel: function ($event) {
              scope.row.isPrimary = false;
            }
          }
        }, [_c("el-switch", {
          attrs: {
            slot: "reference"
          },
          slot: "reference",
          model: {
            value: scope.row.isPrimary,
            callback: function ($$v) {
              _vm.$set(scope.row, "isPrimary", $$v);
            },
            expression: "scope.row.isPrimary"
          }
        })], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "Actions",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button", {
          attrs: {
            type: "primary",
            size: "small",
            icon: "el-icon-edit"
          },
          on: {
            click: function ($event) {
              return _vm.toogleDialog("edit", scope.row.id);
            }
          }
        })];
      }
    }])
  })], 1), _c("br")], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;